var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C7.10313 2 8 2.89687 8 4V6H4V4C4 2.89687 4.89687 2 6 2ZM2 4V6C0.896875 6 0 6.89687 0 8V15C0 16.1031 0.896875 17 2 17H10C11.1031 17 12 16.1031 12 15V8C12 6.89687 11.1031 6 10 6V4C10 1.79063 8.20938 0 6 0C3.79063 0 2 1.79063 2 4ZM6.75 10.25V12.75C6.75 13.1656 6.41563 13.5 6 13.5C5.58437 13.5 5.25 13.1656 5.25 12.75V10.25C5.25 9.83438 5.58437 9.5 6 9.5C6.41563 9.5 6.75 9.83438 6.75 10.25Z",
    fill: "#EDAC1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBadge);
export default __webpack_public_path__ + "static/media/lock-badge.248dd7d3ddb5dafd98c4614d6f22e7ab.svg";
export { ForwardRef as ReactComponent };